@if (wrapper.isReady) {
  @if (hasError('required')) {
    <div class="invalid-feedback"
         translate="validation.required"
         [translateParams]="{fieldName: wrapper.getTranslationCode(name)|translate}">
    </div>
  }
  @if (hasError('minlength')) {
    <div class="invalid-feedback"
         translate="validation.minlength"
         [translateParams]="{requiredLength: wrapper.form.controls[name].errors?.['minlength'].requiredLength}">
    </div>
  }
  @if (hasError('maxlength')) {
    <div class="invalid-feedback"
         translate="validation.maxlength"
         [translateParams]="{requiredLength: wrapper.form.controls[name].errors?.['maxlength'].requiredLength}">
    </div>
  }
  @if (hasError('min')) {
    <div class="invalid-feedback"
         translate="validation.min"
         [translateParams]="{requiredMin: wrapper.form.controls[name].errors?.['min'].min}">
    </div>
  }
  @if (hasError('max')) {
    <div class="invalid-feedback"
         translate="validation.max"
         [translateParams]="{requiredMax: wrapper.form.controls[name].errors?.['max'].max}">
    </div>
  }
  @if (hasError('email')) {
    <div class="invalid-feedback">{{ 'validation.email'|translate }}</div>
  }
  @if (hasError('number')) {
    <div class="invalid-feedback">{{ 'validation.number'|translate }}</div>
  }
  @if (hasError('numeric')) {
    <div class="invalid-feedback">{{ 'validation.number'|translate }}</div>
  }
  @if (hasError('integer')) {
    <div class="invalid-feedback">{{ 'validation.number'|translate }}</div>
  }
  @if (hasError('hyperlink')) {
    <div class="invalid-feedback">{{ 'validation.hyperlink'|translate }}</div>
  }
  @if (hasError('constructionDate')) {
    <div class="invalid-feedback">{{ 'validation.constructionDate'|translate }}</div>
  }
  @if (hasError('ngbDate')) {
    <div class="invalid-feedback">{{ 'validation.ngbDate'|translate }}</div>
  }
  <!-- Backend Errors START -->
  @for (valErrorNo of getErrors(); track valErrorNo) {
    <div class="invalid-feedback">
      @for (valError of wrapper.form.controls[name].errors?.[valErrorNo] | keyvalue; track valError) {
        {{ getTranslation(valError.value, {fieldName: wrapper.getTranslationCode(name)|translate}) }}
      }
    </div>
  }
  <!-- Backend Errors END -->
    <!-- Special Errors START -->
    <!-- ContactTypeValidator -->
  @if (hasError('typePersonRequired')) {
    <div class="invalid-feedback">{{ 'validation.contact.typePersonRequired'|translate }}</div>
  }
  <!-- Special Errors END -->
}
